import { Box } from "@mui/material";
import ContentAdmin from "components/contentAdmin";
import { ReactComponent as SVGRadial } from "assets/images/icons/radial.svg";

function SectionOne()
{
	return (
		<Box
			component="section"
			sx={{
				paddingBottom: { xl: "136px", lg: "96px", xs: "48px" },
				backgroundColor: "#698ABF"
			}}
		>
			<div className="wrapper">
				<h2>
					<ContentAdmin
						keyText="mission-one-firstComplete"
						keyContent="section1-title"
						defaultValue="Imagine if you could..."
						position="left"
					/>
				</h2>
				<Box
					component="ul"
					sx={{
						width: { xs: "fit-content", lg: "auto" },
						padding: "unset",
						margin: { xs: "0 auto", lg: "unset" },
						marginTop: { xl: "104px", lg: "72px", xs: "44px" },
						listStyle: "none",
						display: "flex",
						flexDirection: { xs: "column", lg: "row" },
						justifyContent: "space-around",
						gap: "40px",

						"& li": {
							textAlign: { lg: "center" },
							font: {
								xl: "700 40px Lora-Bold",
								lg: "700 28px Lora-Bold",
								xs: "700 18px Lora-Bold"
							},
							color: "#FFF",
							display: "flex",
							flexDirection: { xs: "row", lg: "column" },
							justifyContent: { lg: "center" },
							alignItems: "center",
							gap: "40px 24px"
						},
						"& .icon": {
							"--size": { xl: "80px", xs: "56px" },
							width: "var(--size)",
							height: "var(--size)",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							border: "2px solid #FFFFFF",
							borderRadius: "50%",
							background:
								"linear-gradient(to top, rgba(239, 239, 239, .6) 10%, rgba(239, 239, 239, .1))"
						}
					}}
				>
					<li>
						<div className="icon">
							<SVGRadial />
						</div>
						<span>
							<ContentAdmin
								keyText="mission-one-firstComplete"
								keyContent="section1-list-1"
								defaultValue="Live life\non your terms"
								position="left"
								isDescription
							/>
						</span>
					</li>

					<li>
						<div className="icon">
							<SVGRadial />
						</div>
						<span>
							<ContentAdmin
								keyText="mission-one-firstComplete"
								keyContent="section1-list-1"
								defaultValue="Wake up excited\nand motivated"
								position="left"
								isDescription
							/>
						</span>
					</li>

					<li>
						<div className="icon">
							<SVGRadial />
						</div>
						<span>
							<ContentAdmin
								keyText="mission-one-firstComplete"
								keyContent="section1-list-1"
								defaultValue="Realise your\nfull potential"
								position="left"
								isDescription
							/>
						</span>
					</li>
				</Box>
			</div>
		</Box>
	);
}

export default SectionOne;
